import {SOPutMedia} from '../../core/media/so-put-media';
import {MediaCore} from './media.core';
import {SOGetMedia} from '../../core/media/so-get-media';
import {FormField, SelectionOption} from 'lionheartland';
import {putMediaFormFieldOptions} from './put-media-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePut} from 'lionheartland';

export class RAPutMedia extends BasePut implements AdapterProtocol {
  formFieldOptions = Object.values(putMediaFormFieldOptions);

  RequestClass = SOPutMedia

  constructor(
    public entityCore: MediaCore
  ) {
    super();
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.selectedEntity.uid,
      this.getFormValueFromIdentifier('name'),
      this.getFormValueFromIdentifier('description'),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}